import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { RelatedEntity } from './RelatedEntity'
import type { Tenant } from '../tenant/Tenant'
import { generateEntityId } from '../generateEntityId'

export interface IEntity {
  _id: string
  tags?: string[]
  tenant?: Tenant
  createdAt?: Date
  updatedAt?: Date
}

@ObjectType()
@InputType()
export abstract class Entity implements IEntity {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('ent') })
  _id: string

  @Field(() => [String], { nullable: true })
  @Prop({ type: [String] })
  tags?: string[]

  //we don't expose the tenant property on graphql
  @Prop({ type: RelatedEntity })
  tenant?: Tenant

  @Field(() => Date)
  @Prop({ type: Date })
  createdAt?: Date

  @Field(() => Date)
  @Prop({ type: Date })
  updatedAt?: Date
}
